import { Formik, ErrorMessage } from 'formik';
import React, { useState } from 'react'
import { Modal, Button } from 'react-bootstrap';
import * as Yup from 'yup';
import { BiLoader, BiSolidStar } from "react-icons/bi";
import * as urls from "../../utils/urlConst";
import toastNotify from '../../utils/toastNotify';
import { exceptionLog } from '../../utils/common';
import TextArea from '../../components/textField/TextArea';
import { makeRequest } from '../../utils/makeRequest';

type ticketFeedbackMdlProps = {
    isShow: boolean;
    handleFeedbackMdl: any;
    closedTicket: any;
    setClosedTicket: any;
    fetchPost: any;
};


const TicketFeedbackMdl: React.FC<ticketFeedbackMdlProps> = ({ isShow, handleFeedbackMdl, closedTicket, setClosedTicket, fetchPost }) => {

    const [isLoader, setIsLoader] = useState(false);


    const addFeedback = async (val: any) => {
        try {
            setIsLoader(true);
            const payload = {
                TicketId: closedTicket,
                Ratings: val.rating.toString(),
                Description: val.description
            };
            const config = {};
            await makeRequest("POST", urls.addTicketFeedback, payload, config).then((result) => {
                if (result.STATUS === '0') {
                    toastNotify(result.MESSAGE, 'success');
                    handleFeedbackMdl();
                    setClosedTicket(null);
                    fetchPost();
                } else {
                    toastNotify(result.MESSAGE, 'error');
                }
            }).catch((error) => {
                toastNotify(error, "error");
            })
        } catch (error: any) {
            if (error.status !== 403) {
                await exceptionLog(error, "Ticket Feedback", "N");
            }
        } finally {
            setIsLoader(false);
        }
    }

    return (
        <div>
            <Modal
                show={isShow}
                onHide={handleFeedbackMdl}
                backdrop="static"
                keyboard={false}
            >
                <Modal.Header closeButton>
                    <Modal.Title className='text-base'>Ticket Feedback</Modal.Title>
                </Modal.Header>
                <Formik
                    initialValues={{
                        rating: 0,
                        description: "",
                    }}
                    validationSchema={Yup.object({
                        rating: Yup.string().required('Reating is required field'),
                        description: Yup.string().required('Description is required field'),
                    })}
                    onSubmit={(values) => {
                        addFeedback(values);
                    }}
                >
                    {({ values, handleChange, handleBlur, handleSubmit, setFieldValue }) => {
                        return (
                            <form onSubmit={handleSubmit}>
                                <Modal.Body>
                                    <div>
                                        <div className='mb-3'>
                                            <label htmlFor="" className="required text-xs text-slate-500">
                                                Rating
                                            </label>
                                            <div className="star-rating-section mt-2 mt-md-0">
                                                {[1, 2, 3, 4, 5].map((i) => (
                                                    <div
                                                        key={i}
                                                        className={`star ${values.rating >= i ? "active" : ""} `}
                                                        onClick={() => setFieldValue('rating', i)}
                                                    >
                                                        <BiSolidStar style={{ color: "#ccc !important", fontSize: 25 }} />
                                                    </div>
                                                ))}
                                            </div>
                                            <ErrorMessage name="rating" className='error-msg' component="div" />
                                        </div>
                                        <TextArea
                                            label="Description"
                                            name="description"
                                            id="description"
                                            size="small"
                                            tabIndex={1}
                                            maxLength={200}
                                            required
                                            value={values.description}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                        />
                                        <ErrorMessage name="description" className='error-msg' component="div" />
                                    </div>
                                </Modal.Body>
                                <Modal.Footer>
                                    <Button variant="outline-secondary" onClick={handleFeedbackMdl} className='btn-sm'>
                                        Close
                                    </Button>
                                    <Button variant="orange" type='submit' className='btn-sm' disabled={isLoader} >{!isLoader ? "Submit" : <><BiLoader className='icon-loader text-white text-lg' /> Loading...</>}</Button>
                                </Modal.Footer>
                            </form>
                        )
                    }}
                </Formik>
            </Modal >
        </div>
    )
}

export default TicketFeedbackMdl;
